import { arrayOf, bool, object, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import BaseRecipe from 'components/Recipe';
import RecipeRatingsDataProvider from 'components/RecipeRatingsDataProvider';
import RecipeSupplyAffiliateLinkDataProvider from 'components/RecipeSupplyAffiliateLinkDataProvider';
import styles, { recipeStyles } from './styles';

function AmpRecipe(props) {
  const { recipeId, supplyGroups: baseSupplyGroups } = props;

  return (
    <div className="AmpRecipe">
      <RecipeRatingsDataProvider recipeId={recipeId}>
        {({ ratingsData }) => (
          <Fragment>
            <RecipeSupplyAffiliateLinkDataProvider
              supplyGroups={baseSupplyGroups}
            >
              {({ supplyGroups }) => (
                <BaseRecipe
                  {...props}
                  ratingsData={ratingsData}
                  supplyGroups={supplyGroups}
                  showNutrition
                  isAmp
                  styles={recipeStyles}
                />
              )}
            </RecipeSupplyAffiliateLinkDataProvider>
          </Fragment>
        )}
      </RecipeRatingsDataProvider>
      <style jsx>{styles}</style>
    </div>
  );
}

AmpRecipe.defaultProps = {
  post: undefined,
  supplyGroups: [],
  hideAds: false
};

AmpRecipe.propTypes = {
  title: string.isRequired,
  recipeId: string.isRequired,
  post: shape({
    ads: shape({
      targeting: object,
      tags: arrayOf(string)
    })
  }),

  // only describing locally-relevant props for addAffiliateLinksToSupplies()
  supplyGroups: arrayOf(
    shape({
      items: arrayOf(
        shape({
          affiliateLink: shape({
            url: string
          })
        })
      )
    })
  ),

  hideAds: bool
};

export default AmpRecipe;
